import { WorkScheduleHoursDto, type WorkScheduleHoursInterface } from '@zaoblako/shared/modules/security/dtos/work-schedule/work-schedule-hours.dto';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';

import * as yup from 'yup';

/** Work schedule create/update request body */
export interface WorkScheduleFormInterface {
  /** Schedule display name */
  name: string;
  /** Work hours count per days of week */
  hours: WorkScheduleHoursInterface;
}

/** Work schedule create/update request body - DTO schema */
export const WorkScheduleFormDto = SerdeDtoClass.create<WorkScheduleFormInterface>(SecurityDtoKeysEnum.WORK_SCHEDULE_FORM_DTO, {
  name: {
    sortable: true,
    label: 'Название',
    serializer: yup
      .string()
      .min(1, DtoMessageEnum.EMPTY_STRING),
  },
  hours: {
    label: 'График',
    nested: WorkScheduleHoursDto,
    serializer: (_, nested) => nested,
  },
});
